import { useEffect, useRef, useState } from 'react';

import { SearchIcon } from '../../../../assets/svg';
import { DeletedIcon } from '../../../../assets/svg/DeletedIcon';
import { Separator } from '../../../../components/separator';
import { useClickOutside } from '../../../../hooks/useClickOutside';
import { paymentTypeOptions } from '../editModal';
import { Input } from '../input';
import { DropdownContainer, Item, List } from './styles';

interface Options {
	label: string;
	value: string;
	show: boolean;
	icon: JSX.Element;
}

interface DropdownProps {
	options?: Options[];
	onChange?: (option: Options) => void;
	state: string;
	clearState?: () => void;
	disabled?: boolean;
}

const DropdownBanks = ({
	options,
	onChange,
	state,
	clearState,
	disabled = false,
}: DropdownProps) => {
	const elementRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState(state);
	const [showCrossIcon, setShowCrossIcon] = useState(false);
	const [selected, setSelected] = useState(state ? true : false);

	const [filteredOptions, setFilteredOptions] = useState(options);

	useClickOutside({ elementRef, callback: () => setIsOpen(false) });

	const handleSetSearchTerm = (value: string) => {
		setSearchTerm(value);
		if (value != '') {
			!selected && setSelected(true);
			!showCrossIcon && setShowCrossIcon(true);
			setFilteredOptions(
				options?.filter((option) => option.label.toLowerCase().includes(value.toLowerCase())),
			);
			setIsOpen(true);
		} else {
			setSelected(false);
			clearState && clearState();
			setShowCrossIcon(false);
		}
	};

	const handleSelectOption = (option: Options) => {
		setSearchTerm(option.label);
		onChange && onChange(option);
		setIsOpen(false);
		setSelected(true);
	};

	useEffect(() => {
		//If a bank is selected, close the dropdown
		if (selected) {
			setIsOpen(false);
			setShowCrossIcon(true);
		} else {
			setShowCrossIcon(false);
		}
	}, [selected]);

	const leftIcon = selected ? (
		paymentTypeOptions?.filter((item) => item.label === searchTerm)[0]?.icon
	) : (
		<SearchIcon color="red" />
	);

	return (
		<DropdownContainer ref={elementRef} isOpen={isOpen} disabled={disabled}>
			<Input
				type="text"
				label="Banco"
				placeholder="Buscar"
				variant="large"
				value={searchTerm}
				onClick={() => {
					setIsOpen(!isOpen);
				}}
				onChange={(e) => {
					handleSetSearchTerm(e.target.value);
				}}
				leftIcon={leftIcon}
				rightIcon={
					<DeletedIcon
						style={{
							display: `${showCrossIcon && !disabled ? 'initial' : 'none'}`,
						}}
					/>
				}
				rightIconClick={() => {
					handleSetSearchTerm('');
				}}
				labelFocus
				disabled={disabled}
				fontSize="16px"
			/>

			{isOpen && !disabled && (
				<List>
					{filteredOptions?.map((option: Options, i: number) => (
						<>
							<div key={i} style={{ padding: '5px 3px' }}>
								<Item
									onClick={() => {
										handleSelectOption(option);
										setIsOpen(false);
									}}
								>
									{option.icon}
									<span className="dropdown-item">
										{option.label
											.split(new RegExp(`(${searchTerm})`, 'gi'))
											.map((text: string, i: number) => (
												<span
													key={i}
													style={{
														color:
															text.toLowerCase() === searchTerm.toLowerCase()
																? '#140F33'
																: '#B7B7B7',
													}}
												>
													{text}
												</span>
											))}
									</span>
								</Item>
							</div>
							<Separator />
						</>
					))}
				</List>
			)}
		</DropdownContainer>
	);
};

export default DropdownBanks;
